/**
 * Gebäude-Typen und Definitionen.
 * 4 Fabriken (produzieren Ressourcen/Energie) + 3 Lager (erhöhen Kapazität).
 */

export type BuildingType =
  | 'feronium_mine' | 'chrysalium_burner' | 'neurogel_extractor' | 'solar_collector'
  | 'feronium_storage' | 'chrysalium_storage' | 'neurogel_tank';

export type BuildingCategory = 'factory' | 'storage';

export interface CostWeights {
  readonly feronium: number;
  readonly chrysalium: number;
  readonly neurogel: number;
}

export interface BuildingDef {
  readonly type: BuildingType;
  readonly category: BuildingCategory;
  readonly name: string;
  readonly icon: string;
  readonly maxLevel: number;
  readonly baseRate: number;      // Produktion/s (factory) oder Kapazität (storage)
  readonly baseEnergy: number;    // Energieverbrauch/s (0 bei Lagern, negativ = erzeugt)
  readonly costWeights: CostWeights;
}

export const ALL_BUILDING_TYPES: readonly BuildingType[] = [
  'feronium_mine', 'chrysalium_burner', 'neurogel_extractor', 'solar_collector',
  'feronium_storage', 'chrysalium_storage', 'neurogel_tank',
] as const;
